<template>
    <div class="app-inner">
        <div class="searchTitleDiv">
            <div class="stateDiv">
                <p class="searchText">状态</p>
                <el-select v-model="searchFrom.status" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="stateDiv">
                <p class="searchText">编码</p>
                <el-input v-model="searchFrom.eventId" clearable placeholder="请输入" style="width:220px"></el-input>
            </div>
            <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
            <el-button class="searchBtn" type="warning" @click="addFormData">申请</el-button>
        </div>
        <!--      列表-->
        <div class="table">
            <div class="searchList">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="我的加班申请" name="mine"></el-tab-pane>
                    <el-tab-pane label="待我审批" name="approve">
                        <div slot="label">
                            待我审批
                            <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="已审批" name="finishApproval"></el-tab-pane>
                    <!-- <el-tab-pane label="待我审批" name="approve"></el-tab-pane> -->
                </el-tabs>
                <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount"
                    @pageChange="handleCurrentChange">
                    <template #action="{ row, index }" class="tableButton">
                        <!-- <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small">编辑
                        </el-button> -->
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
                        </el-button>
                        <el-button class="tableBtn" @click="approval(row, 'view')"
                            v-if="row.status == 0 && activeName == 'mine'" type="text" size="small">催批
                        </el-button>
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'update')"
                            v-if="(row.status == 2 || row.status == 10) && activeName == 'mine'" type="text" size="small">修改
                        </el-button>
                        <!-- <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small">删除</el-button> -->
                    </template>
                </TableList>
            </div>
        </div>
        <!--    新增/编辑弹框-->
        <div class="dialogDiv">
            <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
                <el-form ref="addForm" :model="addForm" :rules="rules" label-width="150px">
                    <el-row v-if="eventControlType !== 'add'">
                        <el-form-item label="编号" prop="eventId" class="formItem">
                            <el-input v-model="addForm.eventId" clearable placeholder="请输入" disabled />
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="开始时间" prop="begin" class="formItem">
                            <el-date-picker v-model="addForm.begin" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                @change="beginTime" :disabled="eventControlType !== 'add'" placeholder="选择日期时间"
                                style="width:100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="结束时间" prop="end" class="formItem">
                            <el-date-picker v-model="addForm.end" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                @change="endTime" :disabled="eventControlType !== 'add'" placeholder="选择日期时间"
                                style="width:100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="加班时长" prop="dayCount" class="formItem">
                            <el-input-number v-model="addForm.dayCount" :min="0.5" :max="100" placeholder="大于等于0.5"
                                :disabled="eventControlType !== 'add'" style="width:90%;margin-right:5px"
                                :controls="false"></el-input-number>天
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="申请事由" prop="applyReason" class="formItem">
                            <el-input type="textarea" v-model="addForm.applyReason" clearable placeholder="请输入"
                                :disabled="eventControlType !== 'add'" maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="activeNameNew == 'approve'">
                        <el-form-item label="审核状态" prop="status" class="formItem" v-if="addForm.approvalFlag">
                            <el-select style="width:100%" v-model="addForm.status" placeholder="请选择" class="inputDiv"
                                clearable @change="handleRemark">
                                <el-option :value="item.value" :label="item.label" v-for="(item, index) in statusOptions1"
                                    :key="index" />
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="activeNameNew == 'approve'">
                        <el-form-item label="审核原因" class="formItem" v-if="addForm.approvalFlag">
                            <el-input type="textarea" v-model="addForm.remark" clearable placeholder="请输入" maxlength="500"
                                show-word-limit @input="changeMessage($event)"></el-input>
                        </el-form-item>
                    </el-row>
                    <template v-if="eventControlType === 'add' || addForm.status === 0">
                        
                        <approvalRadio  v-model="isSubmitApproval"/>
                        <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeNameNew == 'mine'">
                            <el-select v-model="addForm.auditPersonId" style="width:100%" placeholder="请选择" clearable
                                filterable :disabled="eventControlType === 'edit'">
                                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName"
                                    :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <template v-if="activeNameNew == 'approve'">
                        
                        <approvalRadio  v-model="isSubmitApproval" v-show="addForm.status == '3'"/>

                        <el-form-item label="转办人" prop="nextAuditUserName" v-if="addForm.status == '3'">
                            <el-select v-model="addForm.nextAuditUserName" style="width:100%" placeholder="请选择" clearable
                                filterable>
                                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName"
                                    :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <template v-if="activeNameNew == 'approve'">
                        <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="addForm.status == '1'">
                            <el-radio v-model="addForm.lastUserFlag" :label="1">是</el-radio>
                            <el-radio v-model="addForm.lastUserFlag" :label="0">否</el-radio>
                        </el-form-item>

                        <approvalRadio  v-model="isSubmitApproval" v-show="addForm.status == '1' && addForm.lastUserFlag == 0"/>
                        
                        <el-form-item label="下一级审核人" prop="nextAuditUserName"
                            v-if="addForm.status == '1' && addForm.lastUserFlag == 0">
                            <el-select style="width:100%" v-model="addForm.nextAuditUserName" placeholder="请选择" clearable
                                filterable>
                                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName"
                                    :value="item.userName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-row>
                        <review-process :processList="addForm.auditProcessEntityList" :createTime="addForm.createTime"
                            :createUser="addForm.applyUser" :auditPerson="addForm.auditPerson" />
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitArrroval()" v-if="addForm.approvalFlag">提交</el-button>
                    <el-button type="primary" @click="addEventForm()" v-if="eventControlType == 'add'">提交</el-button>
                    <el-button type="primary" @click="saveEventForm()"
                        v-if="(eventControlType === 'add' && addForm.status === 10) || (eventControlType === 'add' && addForm.status === '')">暂
                        存</el-button>
                    <el-button @click="closeData">取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { compApplyOvertime } from '@/api/comprehensive'
// import { validPassword } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
import ReviewProcess from '@/components/ReviewProcess.vue'
// import { queryUserInfo } from '@/api/basicInfo'
import approval from '@/mixins/approval'

export default {
    mixins: [approval],
    name: 'accountPage',
    components: {
        TableList,
        ReviewProcess
    },
    data() {
        return {
            loading: false,
            searchFrom: {
                status: '',
                eventId: ''
            },
            activeName: 'mine',
            activeNameNew: 'mine',
            currentPage: 1,
            totalCount: 0,
            workNumber: 0,
            pageSize: 10,
            dialogFormVisible: false,
            eventControl: '',
            eventControlType: '',
            edit: false,
            passwordForm: {},
            statusOptions1: [
                {
                    value: '1',
                    label: '通过'
                },
                {
                    value: '2',
                    label: '拒绝'
                },
                {
                    value: '3',
                    label: '转办'
                },
                {
                    value: '4',
                    label: '退回上一级'
                },
            ],
            addForm: {
                begin: '', // 使用开始时间
                end: '', // 使用结束时间
                dayCount: null, // 加班时长
                applyReason: '', // 申请原因
                remark: '', // 拒绝原因
                createTime: '',
                applyUser: '',
                auditProcessEntityList: [],
                status: '',
                eventId: '',
                lastUserFlag: '',
                nextAuditUserName: '',
                auditPersonId: '',
            },
            rules: {
                begin: [{ required: true, message: '请填写', trigger: 'blur' }],
                end: [{ required: true, message: '请填写', trigger: 'blur' }],
                dayCount: [{ required: true, message: '请填写', trigger: 'blur' }],
                applyReason: [{ required: true, message: '请填写', trigger: 'blur' }],
                status: [{ required: true, message: '请选择', trigger: 'change' }],
                remark: [{ required: true, message: '请填写', trigger: 'blur' }],
                nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
                auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
                lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
            },
            tableData: [],
            // userInfoList: [],
            statusOptions: [
                {
                    label: '待审核',
                    value: 0
                },
                {
                    label: '已通过',
                    value: 1
                },
                {
                    label: '已拒绝',
                    value: 2
                },
                {
                    label: '暂存',
                    value: 10
                },
            ],
            tableColumns: [
                {
                    label: '编号',
                    prop: 'eventId'
                },
                {
                    prop: 'applyUser',
                    label: '申请人'
                },
                {
                    prop: 'auditPerson',
                    label: '审核人',
                    formatter: (row, column, v) => {
                        return row.auditPerson !== '' ? row.auditPerson : row.preAuditPerson
                    }
                },
                {
                    prop: 'status',
                    label: '申请状态',
                    formatter: (row, column, v) => {
                        return (this.statusOptions.find(v => v.value === row.status)).label
                    }
                },
                {
                    prop: 'begin',
                    label: '开始时间'
                },
                {
                    prop: 'end',
                    label: '结束时间'
                },

                {
                    prop: 'dayCount',
                    label: '加班时长(天)'
                },
                {
                    prop: 'action',
                    label: '操作',
                },
            ]
        }
    },
    mounted() {
        this.getData()
        this.queryList()
    },
    methods: {
        handleStatus(creatUser) {
            let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
            if (userName === creatUser) {
                this.statusOptions1 = [
                    {
                        value: '1',
                        label: '通过'
                    },
                    {
                        value: '2',
                        label: '拒绝'
                    },
                    {
                        value: '3',
                        label: '转办'
                    },
                ]
            }
        },
        handleRemark(val) {
      if (val === '1') {
        this.addForm.remark = '同意'
      } else if (val === '3') {
        this.addForm.remark = '转办'
      } else {
        this.addForm.remark = ''
      }
    },
        // 强制更新测试文本信息框的值
        changeMessage() {
            this.$forceUpdate()
        },
        // async queryUser() {
        //     let res = await queryUserInfo({
        //         pageNum: 1,
        //         pageSize: 9999,
        //     })
        //     if (res.code === 0) {
        //         this.userInfoList = res.result.records
        //     }
        // },
        getData() {
            this.currentPage = 1
            this.queryDataList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.queryDataList()
        },
        handleClick(val) {
            this.activeName = val.name
            this.activeNameNew = val.name
            this.queryDataList()
        },
        async queryDataList() {
            let res = await compApplyOvertime(this.activeName === 'mine' ? 'queryMine' : this.activeName === 'approve' ? 'queryMyAudit' : 'listApplyAudited', {
                ...this.searchFrom,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
            if (res.code === 0) {
                this.tableData = res.result.records
                this.totalCount = res.result.total
                this.getNum()
            }
        },
        async getNum() {
            let res = await compApplyOvertime('queryMyAudit', {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
            if (res.code === 0) {
                this.workNumber = res.result.total
            }
        },
        addFormData() {
            this.edit = false
            this.dialogFormVisible = true
            this.eventControlType = 'add'
            this.eventControl = '加班申请'
            this.activeNameNew = 'mine'
        },
        async viewOrHandle(row, type) {
            console.log(row);
            this.edit = true
            this.activeNameNew = this.activeName
            if (type === 'view') {
                this.eventControlType = 'edit'
            } else {
                this.eventControlType = 'add'
            }
            this.eventControl = this.activeName === 'mine' ? '查看详情' : '待审批'
            const { code, result } = await compApplyOvertime('getApplyDetail', {
                id: row.id,
            })
            if (code === 0) {
                this.addForm = {
                    auditPerson: row.auditPerson,
                    begin: row.begin, // 使用开始时间
                    end: row.end, // 使用结束时间
                    dayCount: row.dayCount, // 加班时长
                    applyReason: row.applyReason, // 申请原因
                    eventId: row.eventId,
                    id: row.id,
                    createTime: result.createTime,
                    applyUser: result.applyUser,
                    approvalFlag: result.approvalFlag,
                    auditProcessEntityList: result.auditProcessEntityList,
                    lastUserFlag: result.lastUserFlag,
                    nextAuditUserName: result.nextAuditUserName,
                    auditPersonId: result.auditPersonId,
                    status: result.approvalFlag === true ? '' : result.status,
                }
                this.handleStatus(result.createUser)
            }
            // this.newOldFormContrast(row)
            this.dialogFormVisible = true
        },
        newOldFormContrast(newForm) {
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = newForm[key]
            })
            this.addForm.id = newForm.id
        },
        closeData() {
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
            this.addForm = this.$options.data.call(this).addForm
        },
        submitArrroval() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res = await compApplyOvertime('auditAndNextUser', {
                        id: this.addForm.id,
                        remark: this.addForm.remark,
                        status: this.addForm.status,
                        lastUserFlag: this.addForm.lastUserFlag,
                        nextAuditUserName: this.addForm.nextAuditUserName,
                    })
                    if (res.code === 0) {
                        Message.success('审批成功！')
                        this.closeData()
                        await this.getData()
                    } else {
                        Message.warning({ message: res.message })
                    }
                }
            })
        },
        addEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res = await compApplyOvertime('submitApply', {
                        applyReason: this.addForm.applyReason, // 申请原因
                        begin: this.addForm.begin, // 使用开始时间
                        end: this.addForm.end, // 使用结束时间
                        dayCount: this.addForm.dayCount, // 请假时长
                        auditPersonId: this.addForm.auditPersonId,
                        eventId: this.addForm.eventId,
                        id: this.addForm.id
                    })
                    if (res.code === 0) {
                        Message.success('新增成功！')
                        this.closeData()
                        await this.getData()
                    } else {
                        Message.error(res.message)
                    }
                }
            })
        },
        // 暂存
        saveEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res = await compApplyOvertime('stagingApply', {
                        leaveType: this.addForm.leaveType, // 假期类型
                        applyReason: this.addForm.applyReason, // 申请原因
                        begin: this.addForm.begin, // 使用开始时间
                        end: this.addForm.end, // 使用结束时间
                        dayCount: this.addForm.dayCount, // 请假时长
                        auditPersonId: this.addForm.auditPersonId,
                        eventId: this.addForm.eventId
                    })
                    if (res.code === 0) {
                        Message.success('暂存成功！')
                        this.closeData()
                        await this.getData()
                    } else {
                        Message.error(res.message)
                    }
                }
            })
        },
        // 删除用户
        deleteFun(row) {
            this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    'id': row.id
                }
                let res = await compApplyOvertime('delete', params)
                if (res.code === 0) {
                    Message.success('删除成功！')
                }
                await this.getData()
            })
        },
        async approval(row) {
            this.$confirm('此操作将进行催批, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    'id': row.id
                }
                let res = await compApplyOvertime('sendSmsAuditPersonAgain', params)
                if (res.code === 0) {
                    this.$message({ type: 'success', message: '催批成功!' })
                }
                await this.getData()
            })
        },
        beginTime() {
            if (this.addForm.end) {
                if (this.addForm.begin > this.addForm.end) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message.warning('开始时间不能大于结束时间')
                    }
                    this.addForm.begin = ''
                }
            }
        },
        endTime() {
            if (this.addForm.begin) {
                if (this.addForm.end < this.addForm.begin) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message.warning('结束时间不能小于开始时间')
                    }
                    this.addForm.end = ''
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
}

.searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/

    .stateDiv {
        margin-top: 0.14rem;
        margin-left: .3rem;
        float: left;
    }

    .searchText {
        margin-top: 0.05rem;
        margin-right: 0.13rem;
        font-size: 0.2rem;
        color: #606266;
        float: left;
    }

    .inputDiv {
        width: 2.2rem;
        float: left;
    }

    .searchBtn {
        /*width: 1.20rem;*/
        /*height: 0.36rem;*/
        /*border-radius: 0.06rem;*/
        /*font-size: 0.18rem;*/
        margin-top: 0.14rem;
        margin-left: .3rem;
        /*padding-top: 0.1rem;*/
    }
}

.table {
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;

    .searchList {}

    .paginationBody {
        margin-top: .1rem;
    }
}

.formItem {
    // width: 3.2rem;
}

/deep/ .el-dialog {
    width: 30% !important;
}</style>
